import { render } from "./ModalFlashSale.vue?vue&type=template&id=fc5bf1f0&scoped=true"
import script from "./ModalFlashSale.vue?vue&type=script&lang=js"
export * from "./ModalFlashSale.vue?vue&type=script&lang=js"

import "./ModalFlashSale.vue?vue&type=style&index=0&id=fc5bf1f0&lang=scss&scoped=true"

import exportComponent from "/var/www/production/app.labparahita.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc5bf1f0"]])

export default __exports__